import { AxiosResponse } from 'axios';

import { API_CASINO_GAME_CATEGORY_GAME_ORDER_UPDATE_ORDER } from '../../../../crm/casino/pages/Helpers/CrmApiUrls';
import AbstractCasinoCRMApi from '../../AbstractCasinoCRMApi';

class CasinoGameCategoryGameOrderApi extends AbstractCasinoCRMApi {
    public updateOrder(id: number, order: number): Promise<boolean> {
        return this.patch(API_CASINO_GAME_CATEGORY_GAME_ORDER_UPDATE_ORDER, { id, order }).then(
            (response: AxiosResponse) => response.data
        );
    }
}

export default new CasinoGameCategoryGameOrderApi();
